import { configureStore } from '@reduxjs/toolkit'
import { IAuth, authReducer } from './auth.slice';
import { alertReducer } from './alert.slice';
import { usersReducer } from './user.slice';
import { UserData } from '../model/Users';

export type State = {
  auth: IAuth;
  alert: {
      alert: {
          color: string;
          text: string;
          subText: string;
          isOpen: boolean;
      };
  };
  user: {
      users: UserData[];
  };
}

export const store = configureStore({
  reducer: {
    auth: authReducer,
    alert: alertReducer,
    user: usersReducer
  },
});

